import React from 'react';
import styles from './index.module.css';
import { Button } from 'antd';
export const EXPTYPE = {
  frozen: 'frozen',
  expire: 'expire'
}
export default function AccountStatusNotice({
  onBack,
  expireType
}) {
  const params = {
    [EXPTYPE.frozen]: {
      title: '你的账户已被冻结',
      content1: '你的账户已到期或已被校区管理员手动禁用。这意味着你将无法继续登录本平台。',
      content2: '如果你希望继续使用本平台，请联系你的授课教师或校区管理员。'
    },
    [EXPTYPE.expire]: {
      title: '您的账户已到期',
      content1: '您的账户已到期或已被上级主管部门手动关闭。这意味着您将无法继续登录本平台，同时您创建的学员账户也将被同步禁用。',
      content2: '如果您希望继续使用本平台，请联系您的经销商或英荔教育的用户体验保障团队以获取进一步的协助。'
    }
  }
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {/* 左侧 */}
        <img className={styles.cardImg} src="/image/account-expire.webp" alt=""/>
        {/* 右侧 */}
        <div className={styles.cardContent}>
          <h1 className={styles.title}>
            {params[expireType]?.title || ''}
          </h1>

          <p className={styles.desc}>
            {params[expireType]?.content1 || ''}
          </p>
          <p className={styles.desc}>
            {params[expireType]?.content2 || ''}
          </p>
          <div className={styles.extra}>
            <Button
              onClick={onBack}
            >
              返回
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
